import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, SectionLabel } from "@/components/common";
import { useFetch } from "@/lib/api";

export const Capabilities = () => {
  const { data } = useFetch("/services");
  return (
    <section id="capabilities" data-testid="capabilities-section" className="inverse py-24 md:py-36">
      <div className="container-x">
        <div className="grid gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <SectionLabel number="02">Capabilities</SectionLabel>
            <h2 className="mt-6 font-display text-4xl leading-[1] sm:text-5xl lg:text-6xl">Five disciplines. <em className="text-turq">One</em> point of view.</h2>
          </div>
          <p className="self-end text-base leading-relaxed text-silver md:col-span-5 md:col-start-8 md:text-lg">
            Most projects need all five. I move between them so the brand, the campaign, the interface and the code are all expressions of the same idea.
          </p>
        </div>
        <ul className="mt-16 border-t border-line/15">
          {(data || []).map((g, i) => (
            <Reveal key={g.id} delay={i * 0.05}>
              <li className="border-b border-line/15">
                <Link to={`/services#${g.key}`} data-testid={`capability-row-${g.key}`} className="group grid gap-4 py-8 transition-[padding] duration-500 hover:pl-3 md:grid-cols-12 md:items-center md:py-10">
                  <span className="font-mono text-sm text-gold md:col-span-1">{g.number}</span>
                  <span className="font-display text-4xl leading-none transition-colors duration-300 group-hover:text-turq md:col-span-3 md:text-5xl">{g.name}</span>
                  <span className="text-sm leading-relaxed text-silver md:col-span-7">
                    <span className="block text-fg">{g.tagline}</span>
                    <span className="mt-1 block">{g.items.join(" · ")}</span>
                  </span>
                  <ArrowRight className="hidden h-5 w-5 justify-self-end text-gold transition-transform duration-500 group-hover:translate-x-1 md:col-span-1 md:block" aria-hidden />
                </Link>
              </li>
            </Reveal>
          ))}
        </ul>
      </div>
    </section>
  );
};
